import { useTranslation } from "react-i18next";import React from 'react';
import { Card, CardContent } from '@/shared/components/ui/card';
import { ArrowUpRight, ArrowDownRight } from 'lucide-react';
import { cn } from '@/shared/utils';

export const StatCard = ({ title, value, change, icon: Icon, trend = 'up' }) => {const { t } = useTranslation("ezparcel");
  const isPositive = trend === 'up';

  return (
    <Card className="card-elevated">
      <CardContent className="p-6">
        <div className="flex items-start justify-between">
          <div className="flex-1">
            <p className="text-sm font-medium text-muted-foreground">{title}</p>
            <p className="text-3xl font-bold mt-2 text-foreground">{value}</p>
            {change &&
            <div className={cn(
              "flex items-center gap-1 mt-2 text-sm font-medium",
              isPositive ? 'text-green-600' : 'text-red-600'
            )}>
                {isPositive ?
              <ArrowUpRight className="h-4 w-4" /> :

              <ArrowDownRight className="h-4 w-4" />
              }
                <span>{Math.abs(change)}%</span>
                <span className="text-muted-foreground">{t("vsLastWeek", "vs last week")}</span>
              </div>
            }
          </div>
          {Icon &&
          <div className="flex h-12 w-12 items-center justify-center rounded-lg bg-[hsl(var(--primary)/.1)]">
              <Icon className="h-6 w-6 text-[hsl(var(--primary))]" />
            </div>
          }
        </div>
      </CardContent>
    </Card>);

};